// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"868466ae","223":"a9557141","239":"c57391d5","389":"e79cb46c","453":"80e33dda","455":"3cbfc88b","857":"15870031","977":"d6124178"}[chunkId] + ".chunk.js";
};